import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Constant } from '../constant';

@Injectable({
  providedIn: 'root'
})
export class FaceSwapService {

  constructor(private http: HttpClient, private constant: Constant) { }

  /**
   * ส่งรูปใบหน้า + รูปปลายทาง (target) หรือชื่อ template ไปทำ face swap
   * @param face     ไฟล์รูปใบหน้าของผู้ใช้ (required)
   * @param target   ไฟล์รูปปลายทาง (optional ใช้แทน template)
   * @param template ชื่อ template ฝั่ง server (optional ใช้แทน target)
   */
  swap(face: File, target?: File, template?: string): Observable<any> {
    const formData = new FormData();
    formData.append('face', face);

    if (target) {
      formData.append('target', target);
    } else if (template) {
      formData.append('template', template);
    }

    return this.http.post<any>(
      this.constant.API_ENDPOINT + '/face-swap',
      formData,
      {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        })
      }
    );
  }

  // ดึงรูปผลลัพธ์เป็น blob (ใช้ตอนดาวน์โหลด/แชร์)
  getFileAsBlob(url: string): Observable<Blob> {
    return this.http.get(url, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('access_token') }),
      responseType: 'blob'
    });
  }

  // Error handling
  handleError(e) {
    console.log(e);
    if (e.error && e.error.message) {
      return throwError(e.error.message);
    }
    return throwError('');
  }
}
